import { useState } from "react";
import { useParams } from "react-router-dom";
import { useHospitalOrderList } from "../../../../api/member-management/use-hospital-order";
import TitlePage from "../../../../components/section/TitlePage/Titlepage";
import { Dropdown } from "../../../../components/ui/Dropdown/Dropdown";
import Search from "../Components/Search";
import Navigation from "../Components/navigation";
import { HospitalOrderTable } from "./hospital-order-table";

const searchOptions = [
  { id: "productName", name: "상품명" },
  { id: "orderNo", name: "주문번호" },
];

const HospitalDetailOrderPage = () => {
  const { id } = useParams();
  const [filter, setFilter] = useState({});
  const [keyword, setKeyword] = useState("");
  const [searchBy, setSearchBy] = useState("productName");
  const { isEmpty, getDataTableProps } = useHospitalOrderList(filter, id);

  const handleSearch = (e) => {
    e.preventDefault();
    setFilter({
      [searchBy]: keyword,
    });
  };

  const onResetFilter = () => {
    setKeyword("");
    setFilter({});
  };

  return (
    <div>
      <TitlePage title="회원조회 > 회원상세" />
      <Navigation id="order" hospitalId={id} />
      <div className="flex mt-8 justify-between">
        <div className="gap-2 flex">
          <Dropdown
            width="w-[10rem]"
            placeholder="상품명"
            textColor="text-black"
            positionDropdown="top-10"
            options={searchOptions}
            onClickItem={(value) => setSearchBy(value)}
          />
          <Search
            placeholder="검색어 입력"
            keyword={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            onSubmit={handleSearch}
            handleSearch={handleSearch}
            onResetFilter={onResetFilter}
          />
        </div>
      </div>
      <div className="mt-4">
        <HospitalOrderTable
          isEmpty={isEmpty}
          getDataTableProps={getDataTableProps}
        />
      </div>
    </div>
  );
};

export default HospitalDetailOrderPage;
